import { defaultDataIdFromObject, InMemoryCache } from '@apollo/client';

export default new InMemoryCache({
  dataIdFromObject(responseObject) {
    if (
      responseObject.__typename &&
      [
        'CompanyCustomFields',
        'UserWorkProfileSubType',
        'ProductSubdirectoryTags',
        'ChatroomSeen',
      ].includes(responseObject.__typename)
    ) {
      return undefined;
    }

    if (responseObject._id) {
      return `${responseObject.__typename}:${responseObject._id}`;
    }
    if (responseObject.id) {
      return `${responseObject.__typename}:${responseObject.id}`;
    }

    if (responseObject.filenameUrl) {
      return `${responseObject.__typename}:${responseObject.filenameUrl}`;
    }

    if (responseObject.filename) {
      return `${responseObject.__typename}:${responseObject.filename}`;
    }

    if (responseObject._id) {
      return defaultDataIdFromObject(responseObject);
    }

    return undefined;
  },
});
